<template>
    <v-list-item 
        class="px-0" 
        :ripple="false"
    >
        <v-list-item-title >
            <span class="text-none">
                {{ title }}
            </span>
            <span class="font-weight-bold">
                {{selectedValue }}
            </span>
        </v-list-item-title>
        <v-spacer></v-spacer>
        <v-btn 
            icon 
            :ripple="false" 
            @click.prevent="toggleContent"
        >
            <v-icon class="mdi">
                {{ contentHidden ? 'mdi-chevron-down' : 'mdi-chevron-up' }} 
            </v-icon>
        </v-btn>
    </v-list-item>
</template>

<script> 
    export default {
        name: 'SubStepHeader',
        props: {
            title: {
                type: String,
                required: true
            },
            selectedValue: {
                type: String,
                required: true
            },
            contentHidden: {
                type: Boolean,
                required: true,
            }
        },
        methods: {
            toggleContent() {
                this.$emit('toggle-content');
            },
        },        
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/SubStepHeader.vue